export const initialTableData = [
	{ id: 1, description: "Te Regjistruara", numberOfOrders: 0 },
	{ id: 2, description: "Gati për grumbullim", numberOfOrders: 0 },
	{ id: 3, description: "Grumbulluar", numberOfOrders: 0 },
	{ id: 4, description: "Ne Depo", numberOfOrders: 0 },
	{ id: 5, description: "Ne Transport", numberOfOrders: 0 },
	{ id: 6, description: "Dorëzuar", numberOfOrders: 0 },
	{ id: 7, description: "Refuzuar", numberOfOrders: 0 },
	{ id: 8, description: "Në pritje", numberOfOrders: 0 },
	{ id: 9, description: "Në pritje për tërheqje", numberOfOrders: 0 },
	{ id: 10, description: "Kthyer", numberOfOrders: 0 },
	{ id: 11, description: "Ndërrim", numberOfOrders: 0 },
	{ id: 12, description: "Rinisur", numberOfOrders: 0 },
	{ id: 13, description: "Ne Depon për kthim", numberOfOrders: 0 },
	{ id: 14, description: "Ne Transport Internacional", numberOfOrders: 0 },
	{ id: 15, description: "Kthim ndrrimi", numberOfOrders: 0 },
	{ id: 16, description: "Shpagim", numberOfOrders: 0 },
	{ id: 17, description: "Anulim", numberOfOrders: 0 },
	{ id: 18, description: "Flet Kthimi", numberOfOrders: 0 },
	{ id: 1410, description: "Duke u kthyer", numberOfOrders: 0 },
	{ id: 144, description: "Ne Depo Internacionale", numberOfOrders: 0 },
];
